import { render, staticRenderFns } from "./WizardOverview.vue?vue&type=template&id=8ca13ce6&"
import script from "./WizardOverview.vue?vue&type=script&lang=js&"
export * from "./WizardOverview.vue?vue&type=script&lang=js&"
import style0 from "./WizardOverview.vue?vue&type=style&index=0&id=8ca13ce6&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports